import { render, staticRenderFns } from "./handleAgency.vue?vue&type=template&id=09d03e3d&scoped=true"
import script from "./handleAgency.vue?vue&type=script&lang=js"
export * from "./handleAgency.vue?vue&type=script&lang=js"
import style0 from "./handleAgency.vue?vue&type=style&index=0&id=09d03e3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d03e3d",
  null
  
)

export default component.exports